"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProductsSummary = void 0;
const get_products_summary_stream_1 = require("./get-products-summary-stream");
const stream_1 = require("../../stream");
const getProductsSummary = (client) => async () => {
    return (0, stream_1.unwrapStream)(await (0, get_products_summary_stream_1.getProductsSummaryStreamResponse)(client)());
};
exports.getProductsSummary = getProductsSummary;
